import { db } from "../../services/firebase/Config";
import firebase from "firebase/app";
import { setCuenta } from "../cuenta/cuentaActions";
import {
  updateDienteEnOdontograma,
  setOdontograma,
} from "../odontograma/odontogramaActions";
import { getPrestacion as fetchPrestacion } from "../../services/firebase/prestaciones/index";
import {
  DefaultConfig,
  aplicarCaras,
  aplicarCorona,
  aplicarImplante,
  aplicarExodoncia,
  aplicarNucleo,
} from "../../components/ConfigDiente.js";

import {
  ADD_NOTA_CLINICA,
  REMOVE_NOTA_CLINICA,
  UPDATE_NOTA_CLINICA,
  GET_PRESTATION,
  SET_PRESTATION,
  NEW_PRESTATION,
  SAVE_PRESTATION_REQUEST,
  ADD_PRESTATION_SUCCESS,
  UPDATE_PRESTATION_SUCCESS,
  SAVE_PRESTATION_FAILURE,
  SET_CARAS,
  PAGAR_PRESTACION,
  REVERTIR_PAGO,
} from "./prestationTypes";

import {
  updatePrestationInArray,
  removePrestationInArray,
} from "../prestations/prestationsActions";

import { httpRequest, httpSuccess, httpFailure } from "../sesion/sesionActions";

export const getPrestation = (payload) => {
  return {
    type: GET_PRESTATION,
    payload,
  };
};
export const setPrestation = (payload) => {
  return {
    type: SET_PRESTATION,
    payload,
  };
};

export const addNotaClinica = (notaClinica) => {
  return {
    type: ADD_NOTA_CLINICA,
    payload: notaClinica,
  };
};

export const updateNotaClinica = (item) => {
  return {
    type: UPDATE_NOTA_CLINICA,
    payload: item,
  };
};

export const removeNotaClinica = (idx) => {
  return {
    type: REMOVE_NOTA_CLINICA,
    payload: idx,
  };
};

export const setCaras = (payload) => {
  return {
    type: SET_CARAS,
    payload,
  };
};

export const newPrestation = () => {
  return {
    type: NEW_PRESTATION,
  };
};

const savePrestationRequest = () => {
  return {
    type: SAVE_PRESTATION_REQUEST,
  };
};

const pagarPrestacion = (montoPago) => {
  return {
    type: PAGAR_PRESTACION,
    payload: montoPago,
  };
};

const revertirPago = (montoPago) => {
  return {
    type: REVERTIR_PAGO,
    payload: montoPago,
  };
};

const addPrestationSuccess = (prestationId) => {
  return {
    type: ADD_PRESTATION_SUCCESS,
    payload: prestationId,
  };
};

const savePrestationFailure = (error) => {
  return {
    type: SAVE_PRESTATION_FAILURE,
    payload: error,
  };
};

export const addPrestation = (prestacion) => {
  return async function (dispatch, getState) {
    const empresaId = prestacion.empresaId || getState().paciente.empresaId;

    // Obtener el tiempo del tratamiento si no está definido
    if (prestacion.tiempo === undefined && prestacion.tratamientoId) {
      try {
        let tiempo = 30; // valor por defecto
        
        // 1. Buscar en tratamientos personalizados de la empresa
        const customDoc = await db
          .collection("empresas")
          .doc(empresaId)
          .collection("tratamientos")
          .doc(prestacion.tratamientoId)
          .get();
          
        if (customDoc.exists && customDoc.data().tiempo !== undefined) {
          tiempo = Number(customDoc.data().tiempo || 0);
        } else {
          // 2. Buscar en tratamientos base
          const baseDoc = await db
            .collection("tratamientos_base")
            .doc(prestacion.tratamientoId)
            .get();
            
          if (baseDoc.exists && baseDoc.data().tiempo !== undefined) {
            tiempo = Number(baseDoc.data().tiempo || 0);
          }
        }
        prestacion.tiempo = tiempo;
      } catch (err) {
        console.error("Error al obtener tiempo del tratamiento:", err);
        prestacion.tiempo = 30;
      }
    } else if (prestacion.tiempo === undefined) {
      prestacion.tiempo = 30;
    }

    dispatch(httpRequest());
    db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("prestaciones")
      .add(prestacion)
      .then((docRef) => {
        dispatch(httpSuccess());
        dispatch(addPrestationSuccess(docRef.id));
      })
      .catch((err) => {
        dispatch(httpFailure(err));
        dispatch(savePrestationFailure(err));
      });
  };
};

export const addTratamiento = (tratamiento) => {
  return function (dispatch) {
    dispatch(savePrestationRequest());
    db.collection("tratamientos").add(tratamiento);
  };
};

export const getPrestacion = (prestacionId) => {
  return function (dispatch) {
    fetchPrestacion(prestacionId)
      .then((prestacion) => {
        dispatch(setPrestation(prestacion));
        dispatch(httpSuccess());
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};
export const updatePrestation = (prestacion) => {
  return function (dispatch, getState) {
    const empresaId = prestacion.empresaId || getState().paciente.empresaId;
    dispatch(savePrestationRequest());
    dispatch(httpRequest());
    db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("prestaciones")
      .doc(prestacion.id)
      .update(prestacion)
      .then(() => {
        dispatch(setPrestation(prestacion));
        dispatch(updatePrestationInArray(prestacion));
        dispatch(httpSuccess());
      })
      .catch((error) => {
        dispatch(httpFailure(error));
      });
  };
};

export const actualizarNotas = (prestacion) => {
  return function (dispatch, getState) {
    const pacienteId = prestacion.pacienteId || getState().paciente.id;
    const empresaId = prestacion.empresaId || getState().paciente.empresaId;
    dispatch(httpRequest());
    let prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("prestaciones").doc(prestacion.id);

    prestacionRef
      .update(prestacion)
      .then(() => {
        dispatch(setPrestation(prestacion));
        dispatch(updatePrestationInArray(prestacion));
        dispatch(httpSuccess());
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};

export const actualizarLaboratorio = (prestacion) => {
  return function (dispatch, getState) {
    const empresaId = prestacion.empresaId || getState().paciente.empresaId;
    dispatch(httpRequest());
    let prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("prestaciones").doc(prestacion.id);
    prestacionRef
      .update({
        lab: prestacion.lab,
      })
      .then(() => {
        dispatch(setPrestation(prestacion));
        dispatch(updatePrestationInArray(prestacion));
        dispatch(httpSuccess());
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};
export const enviarLaboratorio = (prestacion, labId) => {
  return function (dispatch, getState) {
    const empresaId = prestacion.empresaId || getState().paciente.empresaId;
    dispatch(httpRequest());
    let prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("prestaciones").doc(prestacion.id);
    let laboratorioRef = db.collection("laboratorios").doc(labId);
    prestacionRef
      .update({ lab: prestacion.lab })
      .then(() => {
        dispatch(setPrestation(prestacion));
        dispatch(updatePrestationInArray(prestacion));
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });

    laboratorioRef
      .update({
        deuda: firebase.firestore.FieldValue.increment(
          Number(prestacion.lab.precio)
        ),
      })
      .then(() => {
        dispatch(httpSuccess());
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};

export const modificarPrecioTrx = (presta, cuenta, nuevoPrecio) => {
  return function (dispatch, getState) {
    const pacienteId = presta.pacienteId || getState().paciente.id;
    const empresaId = presta.empresaId || getState().paciente.empresaId;
    let prestacion = Object.assign({}, presta);
    let diferenciaPrecio = Number(nuevoPrecio) - Number(presta.precio);
    dispatch(httpRequest());
    let estFin = "PENDIENTE";
    if (Number(nuevoPrecio) === Number(prestacion.pagado)) {
      estFin = "CANCELADO";
    }
    db.runTransaction((transaction) => {
      let prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("prestaciones").doc(prestacion.id);
      let cuentaRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("cuentas").doc(cuenta.id);
      return transaction
        .get(cuentaRef)
        .then((doc) => {
          transaction.update(prestacionRef, {
            precio: nuevoPrecio,
            estfin: estFin,
          });
          let nuevaDeuda = 0;
          prestacion.precio = nuevoPrecio;
          prestacion.estfin = estFin;
          if (doc.exists) {
            nuevaDeuda = doc.data().adeudado + diferenciaPrecio;
            transaction.update(cuentaRef, {
              adeudado: nuevaDeuda,
            });
            cuenta.adeudado = nuevaDeuda;
          }
          return { prestacion, cuenta };
        })
        .then(({ prestacion, cuenta }) => {
          dispatch(setPrestation(prestacion));
          dispatch(updatePrestationInArray(prestacion));
          dispatch(setCuenta(cuenta));
          dispatch(httpSuccess());
        })
        .catch((err) => {
          dispatch(httpFailure(err));
        });
    });
  };
};

export const desactivarPrestacionTrx = (presta, cuenta) => {
  return function (dispatch, getState) {
    const pacienteId = presta.pacienteId || getState().paciente.id;
    const empresaId = presta.empresaId || getState().paciente.empresaId;
    let prestacion = Object.assign({}, presta);
    dispatch(httpRequest());
    db.runTransaction((transaction) => {
      let prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("prestaciones").doc(prestacion.id);
      let cuentaRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("cuentas").doc(cuenta.id);
      return transaction
        .get(cuentaRef)
        .then((doc) => {
          prestacion.estado = "PENDIENTE";
          transaction.update(prestacionRef, {
            estado: prestacion.estado,
            precio: prestacion.precio,
            notasClinicas: [],
            nota: prestacion.nota,
          });
          let nuevaDeuda = 0;

          if (doc.exists) {
            nuevaDeuda = doc.data().adeudado - Number(prestacion.precio);
            transaction.update(cuentaRef, {
              adeudado: nuevaDeuda,
            });
            cuenta.adeudado = nuevaDeuda;
          }
          return { prestacion, cuenta };
        })
        .then(({ prestacion, cuenta }) => {
          dispatch(setPrestation(prestacion));
          dispatch(updatePrestationInArray(prestacion));
          dispatch(setCuenta(cuenta));
          dispatch(httpSuccess());
        })
        .catch((err) => {
          dispatch(httpFailure(err));
        });
    });
  };
};

export const iniciarPrestacionTrx = (presta, cuenta) => {
  return function (dispatch, getState) {
    const pacienteId = presta.pacienteId || getState().paciente.id;
    const empresaId = presta.empresaId || getState().paciente.empresaId;
    const { usuario } = getState().sesion;
    let prestacion = Object.assign({}, presta);
    dispatch(httpRequest());
    return db.runTransaction((transaction) => {
      let prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("prestaciones").doc(prestacion.id);
      let cuentaRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("cuentas").doc(cuenta.id);
      let movimientoRef = db.collection("empresas").doc(empresaId).collection("movimientos").doc();

      return transaction
        .get(cuentaRef)
        .then((doc) => {
          prestacion.estado = "ACTIVO";
          transaction.update(prestacionRef, {
            estado: prestacion.estado,
            precio: prestacion.precio,
            notasClinicas: prestacion.notasClinicas,
            nota: prestacion.nota,
          });
          let nuevaDeuda = 0;

          if (doc.exists) {
            nuevaDeuda = doc.data().adeudado + Number(prestacion.precio);
            transaction.update(cuentaRef, {
              adeudado: nuevaDeuda
            });
            cuenta.adeudado = nuevaDeuda;
            // Nota: Si la logica de negocio implica que 'saldo' es dinero a favor, aumentar deuda no necesariamente baja saldo a menos que sea linea de credito. 
            // Revisando `payPrestacionTrx` reduce deuda y saldo. 
            // Aqui solo subimos deuda.
          }

          // Crear movimiento
          let movimiento = {
              fecha: firebase.firestore.FieldValue.serverTimestamp(),
              monto: Number(prestacion.precio),
              tipo: 'cargo_prestacion', // Tipo de movimiento
              estado: 'completado',
              prestacionId: prestacion.id,
              cuentaId: cuenta.id,
              pacienteId: pacienteId,
              usuario: usuario ? usuario.email : 'sistema',
              descripcion: `Activación de prestación: ${prestacion.tratamiento}`,
              empresaId: empresaId
          };
          transaction.set(movimientoRef, movimiento);

          return { prestacion, cuenta };
        })
        .then(({ prestacion, cuenta }) => {
          dispatch(setPrestation(prestacion));
          dispatch(updatePrestationInArray(prestacion));
          dispatch(setCuenta(cuenta));
          dispatch(httpSuccess());
        })
        .catch((err) => {
          dispatch(httpFailure(err));
        });
    });
  };
};

export const removePrestacionActivaTrx = (presta, cuenta) => {
  return function (dispatch, getState) {
    const pacienteId = presta.pacienteId || getState().paciente.id;
    const empresaId = presta.empresaId || getState().paciente.empresaId;
    let prestacion = Object.assign({}, presta);
    dispatch(httpRequest());
    db.runTransaction((transaction) => {
      let prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("prestaciones").doc(prestacion.id);
      let cuentaRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("cuentas").doc(cuenta.id);
      return transaction
        .get(cuentaRef)
        .then((doc) => {
          prestacion.estado = "ELIMINADO";
          transaction.update(prestacionRef, {
            estado: prestacion.estado,
          });
          let nuevaDeuda = 0;

          if (doc.exists) {
            nuevaDeuda = doc.data().adeudado - Number(prestacion.precio);
            transaction.update(cuentaRef, {
              adeudado: nuevaDeuda,
            });
            cuenta.adeudado = nuevaDeuda;
          }
          return { prestacion, cuenta };
        })
        .then(({ prestacion, cuenta }) => {
          dispatch(setPrestation(prestacion));
          dispatch(removePrestationInArray(prestacion));
          dispatch(setCuenta(cuenta));
          dispatch(httpSuccess());
        })
        .catch((err) => {
          dispatch(httpFailure());
        });
    });
  };
};
export const removePrestacionTrx = (presta) => {
  return function (dispatch, getState) {
    const pacienteId = presta.pacienteId || getState().paciente.id;
    const empresaId = presta.empresaId || getState().paciente.empresaId;
    let prestacion = Object.assign({}, presta);
    dispatch(httpRequest());
    let prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("prestaciones").doc(prestacion.id);
    prestacion.estado = "ELIMINADO";
    prestacionRef
      .update(prestacion)
      .then(() => {
        dispatch(removePrestationInArray(prestacion));
        dispatch(httpSuccess());
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};

export const payPrestacionTrx = (prestacion, cuenta, movimiento) => {
  return function (dispatch, getState) {
    const empresaId = prestacion.empresaId || getState().paciente.empresaId;
    // 1. Validaciones iniciales
    if (!prestacion?.id || !cuenta?.id || !movimiento?.monto) {
      dispatch(httpFailure(new Error("Datos incompletos para el pago")));
      return Promise.reject("Datos incompletos");
    }

    // 2. Validación y normalización de montos
    const monto = Math.round(Number(movimiento.monto) * 100) / 100;
    if (isNaN(monto) || monto <= 0) {
      dispatch(httpFailure(new Error("Monto debe ser un número positivo")));
      return Promise.reject("Monto inválido");
    }

    // 3. Validación de coherencia de datos
    if (Number(prestacion.precio) < (Number(prestacion.pagado) + monto)) {
      dispatch(httpFailure(new Error("El pago excede el precio de la prestación")));
      return Promise.reject("Pago excedente");
    }

    dispatch(httpRequest());

    const batch = db.batch();
    const prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("prestaciones").doc(prestacion.id);
    const cuentaRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("cuentas").doc(cuenta.id);
    const movimientosRef = db.collection("empresas").doc(empresaId).collection("movimientos").doc();

    try {
      // 4. Calcular nuevos valores
      const nuevoPagado = Number(prestacion.pagado) + monto;
      const nuevoEstado = nuevoPagado >= Number(prestacion.precio) ? "CANCELADO" : prestacion.estfin;

      // 5. Actualización de prestación
      batch.update(prestacionRef, {
        pagado: firebase.firestore.FieldValue.increment(monto),
        estfin: nuevoEstado,
        fechaPago: firebase.firestore.FieldValue.serverTimestamp(),
      });

      // 6. Actualización de cuenta (con precisión decimal)
      const incrementoNegativo = -monto;
      batch.update(cuentaRef, {
        adeudado: firebase.firestore.FieldValue.increment(incrementoNegativo),
        saldo: firebase.firestore.FieldValue.increment(incrementoNegativo),
        ultimoMovimiento: firebase.firestore.FieldValue.serverTimestamp(),
      });

      // 7. Registro del movimiento
      batch.set(movimientosRef, {
        ...movimiento,
        monto: monto,
        fecha: firebase.firestore.FieldValue.serverTimestamp(),
        tipo: 'pago_prestacion',
        estado: 'completado',
        prestacionId: prestacion.id,
        cuentaId: cuenta.id,
        empresaId: empresaId
      });

      // 8. Ejecución de la transacción
      return batch.commit()
        .then(() => {
          // Actualizar objetos locales para el estado
          const prestacionActualizada = {
            ...prestacion,
            pagado: nuevoPagado,
            estfin: nuevoEstado
          };

          const cuentaActualizada = {
            ...cuenta,
            saldo: Math.round((Number(cuenta.saldo) - monto) * 100) / 100,
            adeudado: Math.round((Number(cuenta.adeudado) - monto) * 100) / 100
          };

          dispatch(pagarPrestacion(monto));
          dispatch(updatePrestationInArray(prestacionActualizada));
          dispatch(setCuenta(cuentaActualizada));
          dispatch(httpSuccess());

          return { success: true, monto, prestacion: prestacionActualizada, cuenta: cuentaActualizada };
        })
        .catch((err) => {
          console.error("Error en transacción de pago:", err);
          dispatch(httpFailure(err));
          throw err;
        });
    } catch (err) {
      console.error("Error preparando transacción:", err);
      dispatch(httpFailure(err));
      return Promise.reject(err);
    }
  };
};
export const payMultiplePrestationsTrx = (prestaciones, monto, movimiento, cuenta) => {
  return function (dispatch, getState) {
    const empresaId = getState().paciente.empresaId; // Assuming all prestations belong to same patient/empresa which is active
    var batch = db.batch();
    dispatch(httpRequest());
    // Assuming account belongs to the same patient context, if not we need 'cuenta.pacienteId'
    //cuenta does have pacienteId
    let cuentaRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(cuenta.pacienteId).collection("cuentas").doc(cuenta.id);
    let movimientosRef = db.collection("empresas").doc(empresaId).collection("movimientos").doc();
    const PrestacionesOrdenadas = prestaciones.sort((a, b) => a.orden - b.orden);
    PrestacionesOrdenadas.forEach((pr) => {
      let prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pr.pacienteId).collection("prestaciones").doc(pr.id);

      if (Number(pr.pagado) === Number(pr.precio)) {
        pr.estfin = "CANCELADO";
      }
      batch.update(prestacionRef, {
        pagado: Number(pr.pagado),
        estfin: pr.estfin,
      });

      dispatch(updatePrestationInArray(pr));


    })
    cuenta.saldo =
      Math.round((Number(cuenta.saldo) - Number(monto)) * 100) / 100;

    cuenta.adeudado =
      Math.round((Number(cuenta.adeudado) - Number(monto)) * 100) / 100;
    if (cuenta.adeudado < 0)
      cuenta.adeudado = 0

    batch.update(cuentaRef, {
      adeudado: firebase.firestore.FieldValue.increment(
        Math.round(-Number(monto) * 100) / 100
      ),
      saldo: firebase.firestore.FieldValue.increment(
        Math.round(-Number(monto) * 100) / 100
      ),
    });
    movimiento.id = movimientosRef.id
    movimiento.empresaId = empresaId;

    batch.set(movimientosRef, movimiento);

    batch
      .commit()
      .then(() => {
        dispatch(setCuenta(cuenta));
        dispatch(httpSuccess());
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};

export const revertPrestacionTrx = (prestacion, cuenta, pago) => {
  return function (dispatch, getState) {
    const empresaId = prestacion.empresaId || getState().paciente.empresaId;
    var batch = db.batch();
    dispatch(httpRequest());
    let prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("prestaciones").doc(prestacion.id);
    let cuentaRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("cuentas").doc(cuenta.id);
    let movimientosRef = db.collection("empresas").doc(empresaId).collection("movimientos").doc();

    prestacion.pagado = Number(prestacion.pagado) - Number(pago.monto);
    if (prestacion.estfin === "CANCELADO") {
      prestacion.estfin = "PENDIENTE";
    }
    batch.update(prestacionRef, {
      pagado: firebase.firestore.FieldValue.increment(-Number(pago.monto)),
      estfin: prestacion.estfin,
    });
    cuenta.saldo =
      Math.round((Number(cuenta.saldo) + Number(pago.monto)) * 100) / 100;
    cuenta.adeudado =
      Math.round((Number(cuenta.adeudado) + Number(pago.monto)) * 100) / 100;

    batch.update(cuentaRef, {
      adeudado: firebase.firestore.FieldValue.increment(
        Math.round(Number(pago.monto) * 100) / 100
      ),
      saldo: firebase.firestore.FieldValue.increment(
        Math.round(Number(pago.monto) * 100) / 100
      ),
    });

    pago.empresaId = empresaId;
    batch.set(movimientosRef, pago);

    batch
      .commit()
      .then(() => {
        dispatch(revertirPago(pago.monto));
        dispatch(updatePrestationInArray(prestacion));
        dispatch(setCuenta(cuenta));
        dispatch(httpSuccess());
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};

export const terminarPrestacionTrx = (prestacion, cuenta) => {
  return function (dispatch, getState) {
    const pacienteId = prestacion.pacienteId || getState().paciente.id;
    const empresaId = prestacion.empresaId || getState().paciente.empresaId;
    const { usuario } = getState().sesion;
    const usuarioEmail = usuario ? usuario.email : 'sistema';

    dispatch(httpRequest());

    return db.runTransaction(async (transaction) => {
      const prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("prestaciones").doc(prestacion.id);
      
      // We need the account to update debt if applicable
      // If cuenta is not passed, we might need to find it or fail. Assuming it's passed or logic handles it.
      // If no cuenta passed, we can't charge. 
      let cuentaRef = null;
      if (cuenta && cuenta.id) {
          cuentaRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("cuentas").doc(cuenta.id);
      } else {
          // Try to find a default account? Or assume if 'PENDIENTE' we MUST have a cuenta.
          // For now, if no cuenta, we proceed but log warning or skip charge?
          // The UI typically has a cuenta available in state.
          // Let's assume we need to skip charge if no account, but in 'PENDIENTE' -> 'TERMINADO' flow usually implied 'Paying' or 'Doing'.
          // "Si en una atencion user decide terminar... incrementarse deuda".
          // If we don't have account, we can't increment.
      }

      const nuevoEstado = "TERMINADO";
      let totalCargo = 0;

      // Logic: If current status is PENDIENTE, we charge.
      // Relying on passed prestacion.estado for now as per other actions pattern, 
      // but ideally we should read it from DB inside transaction for safety. 
      // Let's read it to be safe.
      const prestacionDoc = await transaction.get(prestacionRef);
      if (!prestacionDoc.exists) throw new Error("Prestación no encontrada");
      
      const currentData = prestacionDoc.data();
      const currentEstado = currentData.estado;

      if (currentEstado === 'PENDIENTE') {
          totalCargo = Number(prestacion.precio);
      }

      // Update Prestation
      transaction.update(prestacionRef, {
        estado: nuevoEstado,
        fechaFin: prestacion.fechaFin || firebase.firestore.FieldValue.serverTimestamp(),
        notasClinicas: prestacion.notasClinicas,
      });

      // Update Account & Create Movement if charge needed
      let cuentaUpdated = { ...cuenta };
      if (totalCargo > 0 && cuentaRef) {
          const cuentaDocTrx = await transaction.get(cuentaRef);
          if (cuentaDocTrx.exists) {
              const nuevaDeuda = cuentaDocTrx.data().adeudado + totalCargo;
              transaction.update(cuentaRef, {
                  adeudado: nuevaDeuda
              });
              cuentaUpdated.adeudado = nuevaDeuda;

              // Create Movement (Updated to new path)
              const movimientoRef = db.collection("empresas").doc(empresaId).collection("movimientos").doc();
              const movimiento = {
                  fecha: firebase.firestore.FieldValue.serverTimestamp(),
                  monto: totalCargo,
                  tipo: 'cargo_prestacion',
                  estado: 'completado',
                  prestacionId: prestacion.id,
                  cuentaId: cuenta.id,
                  pacienteId: pacienteId,
                  usuario: usuarioEmail,
                  descripcion: `Termino de prestación (Auto-cargo): ${prestacion.tratamiento}`,
                  empresaId: empresaId
              };
              transaction.set(movimientoRef, movimiento);
          }
      }

      return { cuenta: cuentaUpdated, prestacion: { ...prestacion, estado: nuevoEstado } };
    }).then(({ cuenta, prestacion }) => {
       dispatch(updatePrestationInArray(prestacion));
       if (cuenta && cuenta.id) {
           dispatch(setCuenta(cuenta));
       }
       dispatch(httpSuccess());
    }).catch((err) => {
       console.error("Error terminando prestación:", err);
       dispatch(httpFailure(err));
    });
  };
};

export const terminarPrestacionOdontoTrx = (prestacion, odontograma, cuenta) => {
  return function (dispatch, getState) {
    const pacienteId = prestacion.pacienteId || getState().paciente.id;
    const empresaId = prestacion.empresaId || getState().paciente.empresaId;
    const { usuario } = getState().sesion;
    const usuarioEmail = usuario ? usuario.email : 'sistema';

    dispatch(httpRequest());

    return db.runTransaction(async (transaction) => {
        // Refs
        const prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("prestaciones").doc(prestacion.id);
        const odontogramasRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("odontogramas");
        
        // If odontograma exists, we update it. If not, we create it.
        // Odontograma object passed in has the updated structure? No, it seems it's the current one.
        // The original logic calculates new items based on prestacion.
        
        let odontogramaId = odontograma.id;
        let odontogramaDb;
        if (odontogramaId) {
          odontogramaDb = odontogramasRef.doc(odontogramaId);
        } else {
          odontogramaDb = odontogramasRef.doc();
          odontogramaId = odontogramaDb.id;
        }

        let cuentaRef = null;
        if (cuenta && cuenta.id) {
            cuentaRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("cuentas").doc(cuenta.id);
        }

        // 1. Read Transaction Data
        const reads = [transaction.get(prestacionRef)];
        if (cuentaRef) reads.push(transaction.get(cuentaRef));
        
        const results = await Promise.all(reads);
        const prestacionDoc = results[0];
        const cuentaDoc = results[1] || null;

        if (!prestacionDoc.exists) throw new Error("Prestación no encontrada");
        const currentEstado = prestacionDoc.data().estado;
        
        let totalCargo = 0;
        if (currentEstado === 'PENDIENTE') {
            totalCargo = Number(prestacion.precio);
        }

        // 2. Logic: Odontogram Updates (Local calculation)
        const newOdontoItems = [...odontograma.items];
        let errorEnLogica = null;

        prestacion.dientes.forEach((d) => {
            let idx = newOdontoItems.findIndex((it) => it.diente === d);
            let itemOdonto = {};
            if (idx > -1) {
                itemOdonto = newOdontoItems[idx];
            } else {
                itemOdonto = new DefaultConfig(d);
                itemOdonto = Object.assign({}, itemOdonto);
            }
            let esPilar = prestacion.pilares ? prestacion.pilares.some((p) => p == d) : false;
            const { grupo } = prestacion.config;
            
            try {
                switch (grupo) {
                    case "CARAS":
                        itemOdonto = aplicarCaras(itemOdonto, prestacion.config, prestacion.caras);
                        break;
                    case "CORONA":
                        if (prestacion.caras.length === 0) throw new Error("Error en la aplicación de corona");
                        itemOdonto = aplicarCorona(itemOdonto, prestacion.config, prestacion.caras, esPilar);
                        break;
                    case "IMPLANTE":
                        itemOdonto = aplicarImplante(itemOdonto, prestacion.config);
                        break;
                    case "NUCLEO":
                        itemOdonto = aplicarNucleo(itemOdonto, prestacion.config);
                        break;
                    case "EXODONCIA":
                        itemOdonto = aplicarExodoncia(itemOdonto, prestacion.config);
                        break;
                    default:
                        // throw new Error("No esta configurado");
                }
            } catch (e) {
                errorEnLogica = e;
            }

            if (idx > -1) {
                newOdontoItems[idx] = itemOdonto;
            } else {
                newOdontoItems.push(itemOdonto);
            }
        });

        if (errorEnLogica) throw errorEnLogica;

        const odontogramaToSave = { ...odontograma, items: newOdontoItems, tipo: "ACTIVO", id: odontogramaId };

        // 3. Updates
        const nuevoEstado = "TERMINADO";

        // Update Prestation
        transaction.update(prestacionRef, {
            estado: nuevoEstado,
            fechaFin: prestacion.fechaFin || firebase.firestore.FieldValue.serverTimestamp(),
            notasClinicas: prestacion.notasClinicas,
        });

        // Update Cuenta
        let cuentaUpdated = cuenta ? { ...cuenta } : null;
        if (totalCargo > 0 && cuentaDoc && cuentaDoc.exists) {
             const nuevaDeuda = cuentaDoc.data().adeudado + totalCargo;
             transaction.update(cuentaRef, {
                 adeudado: nuevaDeuda
             });
             cuentaUpdated.adeudado = nuevaDeuda;

             // Create Movement
             const movimientoRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("movimientos").doc();
             const movimiento = {
                  fecha: firebase.firestore.FieldValue.serverTimestamp(),
                  monto: totalCargo,
                  tipo: 'cargo_prestacion',
                  estado: 'completado',
                  prestacionId: prestacion.id,
                  cuentaId: cuenta.id,
                  pacienteId: pacienteId,
                  usuario: usuarioEmail,
                  descripcion: `Termino de prestación (Auto-cargo): ${prestacion.tratamiento}`,
                  empresaId: empresaId
             };
             transaction.set(movimientoRef, movimiento);
        }

        // Save Odontogram
        transaction.set(odontogramaDb, odontogramaToSave);

        return { 
            cuenta: cuentaUpdated, 
            prestacion: { ...prestacion, estado: nuevoEstado },
            odontograma: odontogramaToSave
        };

    }).then(({ cuenta, prestacion, odontograma }) => {
        dispatch(updatePrestationInArray(prestacion));
        if (cuenta) dispatch(setCuenta(cuenta));
        dispatch(setOdontograma(odontograma));
        
        // Sync Redux
        prestacion.dientes.forEach(d => {
             const updatedItem = odontograma.items.find(it => it.diente === d);
             if (updatedItem) dispatch(updateDienteEnOdontograma(updatedItem));
        });

        dispatch(httpSuccess());
    }).catch((err) => {
        console.error("Error terminando prestación odonto:", err);
        dispatch(httpFailure(err));
    });
  };
};

export const noContinuarPrestacionOdontoTrx = (prestacion) => {
  return function (dispatch, getState) {
    const pacienteId = prestacion.pacienteId || getState().paciente.id;
    const empresaId = prestacion.empresaId || getState().paciente.empresaId;
    var batch = db.batch();
    dispatch(httpRequest());
    //Cambia de estado a la prestacion en la coleccion prestaciones
    var prestacionDb = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("prestaciones").doc(prestacion.id);
    let nuevoEstado = "TERMINADO";
    batch.update(prestacionDb, {
      estado: nuevoEstado,
      fechaFin: prestacion.fechaFin,
      notasClinicas: prestacion.notasClinicas,
    });
    prestacion.estado = nuevoEstado;
    dispatch(updatePrestationInArray(prestacion));

    return batch
      .commit()
      .then(() => {
        dispatch(httpSuccess());
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};

export const guardarOdontoInicialTrx = (
  tratamiento,
  odontograma,
  caras,
  pilares,
  dientes,
  fecha
) => {
  return function (dispatch, getState) {
    const empresaId = odontograma.empresaId || getState().paciente.empresaId;
    const pacienteId = odontograma.pacienteId || getState().paciente.id;
    var batch = db.batch();
    dispatch(httpRequest());
    var diagnosticoDb = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("diagnosticos").doc();
    let diagnostico = {
      id: diagnosticoDb.id,
      pacienteId: pacienteId,
      especialidad: tratamiento.especialidad,
      tratamiento: tratamiento.tratamiento,
      tipo: tratamiento.tipo,
      tiempo: (tratamiento.tiempo !== undefined && tratamiento.tiempo !== null && tratamiento.tiempo !== "") ? Number(tratamiento.tiempo) : 30,
      dientes: dientes,
      caras: caras,
      fecha: new Date(),
      estado: "PENDIENTE", // Pending treatment planning
      tratamientoId: tratamiento.id,
      empresaId: empresaId,
      especialistaId: odontograma.especialistaId,
      nota: "ODONTO. INICIAL."
    };
    //Cambia de estado a la prestacion en la coleccion prestaciones
    //Por cada diente se actualiza en el odontograma
    var odontogramaDb;
    if (odontograma.id) {
      odontogramaDb = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("odontogramas").doc(odontograma.id);
    } else {
      odontogramaDb = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("odontogramas").doc();
      odontograma.id = odontogramaDb.id;
    }

    dientes.forEach((d) => {
      //extraemos el resumen actual del diente
      let idx = odontograma.items.findIndex((it) => it.diente === d);
      let itemOdonto = {};
      if (idx > -1) {
        itemOdonto = odontograma.items[idx];
      } else {
        itemOdonto = new DefaultConfig(d);
        itemOdonto = Object.assign({}, itemOdonto);
      }
      let esPilar = pilares ? pilares.some((p) => p === d) : false;
      const { grupo } = tratamiento.config;
      switch (grupo) {
        case "CARAS":
          itemOdonto = aplicarCaras(itemOdonto, tratamiento.config, caras);
          break;
        case "CORONA":
          itemOdonto = aplicarCorona(
            itemOdonto,
            tratamiento.config,
            caras,
            esPilar
          );
          break;
        case "IMPLANTE":
          itemOdonto = aplicarImplante(itemOdonto, tratamiento.config);
          break;
        case "NUCLEO":
          itemOdonto = aplicarNucleo(itemOdonto, tratamiento.config);
          break;

        case "EXODONCIA":
          itemOdonto = aplicarExodoncia(itemOdonto, tratamiento.config);
          break;

        default:
          throw new Error("No esta configurado");
      }
      if (grupo === "CORONA") {
        if (caras.length === 0)
          throw new Error("Error en la aplicación de corona");
      }
      odontograma.tipo = "INICIAL";
      // actualiza en el odontogramaLocal
      if (idx > -1) {
        odontograma.items[idx] = itemOdonto;
      } else {
        odontograma.items.push(itemOdonto);
      }

      dispatch(setOdontograma(odontograma));
      dispatch(updateDienteEnOdontograma(itemOdonto));
    });

    batch.set(diagnosticoDb, diagnostico);
    batch.set(odontogramaDb, odontograma);

    batch
      .commit()
      .then(() => {
        dispatch(httpSuccess());
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};

export const restaurarPrestacionTrx = (prestacion) => {
  return function (dispatch, getState) {
    const pacienteId = prestacion.pacienteId || getState().paciente.id;
    const empresaId = prestacion.empresaId || getState().paciente.empresaId;
    var batch = db.batch();
    dispatch(httpRequest());

    var prestacionDb = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("prestaciones").doc(prestacion.id);
    let nuevoEstado = "ACTIVO";

    batch.update(prestacionDb, {
      estado: nuevoEstado,
      fechaFin: null
    });

    prestacion.estado = nuevoEstado;
    prestacion.fechaFin = null;

    dispatch(updatePrestationInArray(prestacion));

    return batch
      .commit()
      .then(() => {
        dispatch(httpSuccess());
      })
      .catch((err) => {
        dispatch(httpFailure(err));
        throw err;
      });
  };
};
